import {useMutation} from '@tanstack/react-query';
import vettingUpdaters from '@/api/updaters/vetting';

type UpdateVettingTrackingArgs = {
  onSuccess?: (data: unknown) => void;
  onMutate?: (data: {vettingId: string; tracking: boolean}) => void;
  onError?: (error: unknown, variables: unknown, context: unknown) => void;
  onSettled?: (data: unknown, error: unknown) => void;
};

function useUpdateVettingTracking(args: UpdateVettingTrackingArgs) {
  const {onSuccess, onMutate, onError, onSettled} = args;

  return useMutation({
    mutationKey: ['vettingTracking', 'update'],
    mutationFn: vettingUpdaters.tracking,
    onSuccess,
    onMutate,
    onError,
    onSettled,
  });
}

export default useUpdateVettingTracking;
